import { render } from "./UserCareer.vue?vue&type=template&id=dd3475fa&scoped=true&ts=true"
import script from "./UserCareer.vue?vue&type=script&lang=ts"
export * from "./UserCareer.vue?vue&type=script&lang=ts"

import "./UserCareer.vue?vue&type=style&index=0&id=dd3475fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd3475fa"]])

export default __exports__